<template>
  <div v-if="showBar" id="ActionTab" :key="componentKey">
      <button @click="sendMessage" class="sendMessage">
        <img
          :src="require('@/assets/images/' + $store.getters.assetsPath + 'envelope-fixed-white.svg')"
          alt="Like icon"
        />
        <span>
        {{ $t($i18n.locale).keys.memberProfile.actionTab.sendMessage }}
        </span>
    </button>
          
    <template>
      <span v-if="showFunctionButtons">
        <!--
        <img
          v-if="MemberData.icebreaker_question"
          @click="showIBQ($event)"
          class="openIBQ"
          v-b-tooltip.hover
          :title="$t($i18n.locale + '.keys.tooltips.IBQ_button')"
          :src="require('@/assets/images/' + $store.getters.assetsPath + 'icebreaker-green-button.svg')"
          alt="Like icon"
        />
        -->
      <div 
        class="actionButton sendSmile"
        :class="{
          sent: MemberData.smile_sent == 1,
          loading: smileLoading
        }"
        @click="sendSmile"
        v-b-tooltip.hover
          :title="MemberData.smile_sent == 1 ? '': $t($i18n.locale + '.keys.tooltips.Smile_button')"
        ref="smileButton"
        
      >
        <img
          v-show="MemberData.smile_sent == 1"
          :src="require('@/assets/images/' + $store.getters.assetsPath + 'smile-grey-button.svg')"
          alt="Like icon"
        />
        <img
          v-show="!MemberData.smile_sent"
          :src="require('@/assets/images/' + $store.getters.assetsPath + 'smile-green-button.svg')"
          alt="Like icon"
        />
      </div>
          
      <div 
        class="actionButton makeFavorite"
        @click="toggleBookmark"
                  v-b-tooltip.hover
          :title="
          MemberData.bookmark ? 
          $t($i18n.locale + '.keys.tooltips.FavRemove_button') : $t($i18n.locale + '.keys.tooltips.Fav_button')
          "
        ref="favoriteButton"
      >
        <img
          v-show="MemberData.bookmark == 1"
        :src="require('@/assets/images/' + $store.getters.assetsPath + 'favourite-selected-button.svg')"
        alt="Favorite icon"
      />
      <img
        v-show="!MemberData.bookmark"
        :src="require('@/assets/images/' + $store.getters.assetsPath + 'favourite-green-button.svg')"
        alt="Favorite icon"
      />
      </div>
      </span>

      <div
        v-if="!MemberData.reported"
        @click="showReport"
        class="reportUserBtn"
        v-b-tooltip.hover
        :title="$t($i18n.locale + '.keys.tooltips.Report_button')"
              >
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      </div>

  </template>

   
<!--
    <ModalIcebreakerQuestions ref="modalIBQ" />
-->

    <ModalUserReport ref="modalUserReport" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

//import ModalIcebreakerQuestions from "@/components/membership-area/ModalIcebreakerQuestions.vue";

import ModalUserReport from "@/components/membership-area/member-profile/ModalUserReport.vue";

export default {
  name: "ActionsTab",
components: {
  //ModalIcebreakerQuestions
  ModalUserReport
},
  computed: {
    selectedLanguage: function() {
      return this.$store.getters.selectedLanguage;
    },
    
    ...mapGetters([ "MemberData", "isMobile", "user"]),
    
    currentUUID() {
      return this.$route.query.uuid
    },
    currentID() {
      return parseInt(this.$route.query.id)
    }
  },
  data() {
    return {
      showBar: true,
      showFunctionButtons: false,
      componentKey: 0,
      profileLoaded: false,
      myMatches: null,
      ibqLoader: false,
      selectedIBQId: '',
      currentIBQ: [],
      smileLoading: false,
    };
  },
 updated() {
      if (!this.$route.query.uuid)  {
      this.$router.push("/membership-area/home");
    }
  },
  created() {
      if (!this.$route.query.uuid)  {
      this.$router.push("/membership-area/home");
    }
    this.showFunctionButtons = true;
    //this.getProfile(this.$route.query.id);
    setTimeout(() => {
      this.showBar = true;
    }, 100);


  },
  mounted() {},
  methods: {
    showReport($event){
      //Default Tooltip delay is 50ms
      setTimeout(() => {
        this.$root.$emit('bv::hide::tooltip')  
      }, 55);
      
      this.$refs.modalUserReport.show(this.currentID, $event.currentTarget);
    },
    showIBQ($event){
      this.$refs.modalIBQ.show(this.currentID, $event.currentTarget);
    },
   
    async toggleBookmark() {
        
      this.$refs.favoriteButton.classList.add('loading');
      
      let match_id = this.MemberData.match_id | 0;

      if(!this.MemberData.match_id) {
        const response = await this.$store.dispatch("registerMatch", this.currentID)
        console.log("toggleBookmark response", response)
        if(response == 'error'){
          this.$refs.favoriteButton.classList.remove('loading');
          return false
        } else if(response.id){
          match_id = response.id
        }

      }

      console.log('toggleBookmark', match_id)

      this.$store.dispatch("toggleBookmark", match_id).then(res => {
        this.$refs.favoriteButton.classList.remove('loading');
        console.log('toggleBookmark res', res)
        //this.$refs.smileButton.classList.remove('loading');
        this.updateMemberData();
      });
      
    },
    async sendMessage() {

      let match_id = this.MemberData.match_id | 0;

      if(!this.MemberData.match_id) {
        const response = await this.$store.dispatch("registerMatch", this.currentID)
        if(response == 'error'){
          return false
        } else if(response.id){
          match_id = response.id
        }
      }

      if(this.MemberData.blockSend){
        this.$gtm.trackEvent({
          event: 'NPM',
          category: 'NPM',
          action: 'Send Message Attempt',
          label: 'Chat'
        });
      }
        var match = {
          id: match_id,
          blockSend: this.MemberData.blockSend
        }
        this.$store
          .dispatch("initiateConversation", match)
          .then(res => {
            if (res == "error") {
              // show error
              //this.$store.dispatch("setErrorVisibility", true);
              this.$store.dispatch("hideContent");
            }
          });
        this.$store.dispatch("reRenderMatchesList");
      
    },
    async sendSmile() {
    
      if(this.MemberData.smile_sent == 1 || this.smileLoading) return false;
        this.smileLoading = true;
    
        let match_id = this.MemberData.match_id | 0;

        if(!this.MemberData.match_id) {
        const response = await this.$store.dispatch("registerMatch", this.currentID)
        if(response == 'error'){
          this.smileLoading = false;
          return false
        } else if(response.id){
          match_id = response.id
        }
      }
         

        this.$store.dispatch("sendSmile", match_id).then(res => {
          this.$refs.smileButton.classList.remove('loading');
          if (res == "error") {
            //this.$store.dispatch("setErrorVisibility", true);
            this.$store.dispatch("hideContent");
            this.smileLoading = false;
          } else {
            this.updateMemberData();
          }
        });

    },
    
    updateMemberData() {

      console.log('sendSmile updateMemberData', this.currentUUID)

      this.$store.dispatch("fetchMemberDataUUID", {uuid: this.currentUUID, profile_id: this.currentID}).then(res => {
        console.log('sendSmile fetchMemberData', res)
        this.componentKey++;
        this.smileLoading = false;
      });
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
